import React, { useEffect, useState } from 'react';
import { IFmsWebPageContent, getFmsPagePathError } from '../MobileAppTypes';
import { IScreenEditorProps } from './SharedTypes';

interface IFmsWebPageEditorProps extends IScreenEditorProps {
  content: IFmsWebPageContent;
}

const validate = (contentToValidate: IFmsWebPageContent): string[] => {
  const pathError = getFmsPagePathError(contentToValidate.path);
  return pathError ? [pathError] : [];
};

const FmsWebPageEditor: React.FC<IFmsWebPageEditorProps> = ({
  content,
  onContentChange,
  onValidationChange
}) => {
  const [localContent, setLocalContent] = useState<IFmsWebPageContent>(content);

  useEffect(() => {
    setLocalContent(content);
    // Validate up front too, so a new screen can't be saved with an empty path before any edit.
    onValidationChange(validate(content));
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [content]);

  const updateContent = (updates: Partial<IFmsWebPageContent>) => {
    const newContent = { ...localContent, ...updates };
    setLocalContent(newContent);
    onContentChange(newContent);
    onValidationChange(validate(newContent));
  };

  return (
    <div className="form-section">
      <h4>FMS Page Content</h4>
      <p className="text-muted">
        Opens a page from this event's own FMS site inside the app. Check <strong>Secure Screen</strong> for pages that need the person to be
        signed in (for example their profile): the app signs them into the website first, and the screen only appears in the app once they
        have logged in. Use <strong>Access Role</strong> to limit it further.
      </p>

      <div className="form-horizontal">
        <div className="form-group">
          <label className="col-sm-3 control-label">Page Path*</label>
          <div className="col-sm-9">
            <input
              type="text"
              className="form-control"
              value={localContent.path || ''}
              onChange={(e) => updateContent({ path: e.target.value })}
              placeholder="/app/user/profile/"
            />
            <span className="help-block">
              The part of the page's address after the site name, starting with /. Do not include the site name. For secure pages the
              event (?f=) is added automatically; a public page opens exactly as entered.
            </span>
          </div>
        </div>

        <div className="form-group">
          <label className="col-sm-3 control-label">Title</label>
          <div className="col-sm-9">
            <input
              type="text"
              className="form-control"
              value={localContent.title || ''}
              onChange={(e) => updateContent({ title: e.target.value })}
              placeholder="Optional screen title"
            />
            <span className="help-block">Optional title shown at the top of the screen in the app</span>
          </div>
        </div>
      </div>
    </div>
  );
};

export default FmsWebPageEditor;
